import React from 'react';
import GameCardItem from '../../components/CardItem/GameCardItem';
import { PokemonCard } from '../../types/pokemon';

interface PokemonCardItemProps {
  card: PokemonCard;
  isOwned: boolean;
  isFavorite: boolean;
  isWishlist: boolean;
  onCardClick: (card: PokemonCard) => void;
  onToggleOwnership: (cardId: string) => void;
  onToggleWishlist: (cardId: string) => void;
  onToggleFavorite: (cardId: string) => void;
  isToggling: boolean;
}

const PokemonCardItem: React.FC<PokemonCardItemProps> = (props) => {
  return <GameCardItem {...props} />;
};

export default PokemonCardItem;
